/**
 * Parse a raw textarea string (newline or comma separated) into a clean,
 * deduped list of trimmed answers. Case-insensitive dedupe preserves the
 * first occurrence's original casing. Shared by the question form and its
 * tests.
 */
export function parseValidAnswers(raw: string): string[] {
  const pieces = raw
    .split(/[\n,]+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  const seen = new Set<string>();
  const out: string[] = [];
  for (const piece of pieces) {
    const key = piece.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(piece);
  }
  return out;
}
